import React, { useEffect } from "react";
import { Stack, Typography } from "@mui/material";

import { HubDialogContent, HubHookFormWrapper } from "../../components";
import MergeCustomerForm from "./MergeCustomerForm";
import MergeCustomerButtons from "./MergeCustomerButtons";
import { useHubSnackBar, usePostMergeCustomerData } from "../../hooks";
import { useDialogContext } from "../HubDialogWrapper";

const MergeCustomerContent = () => {
  const {
    mutate: postMergeCustomerData,
    isLoading,
    isSuccess,
    isError,
  } = usePostMergeCustomerData();

  const { onClose = () => {} } = useDialogContext();
  const { addSnackbarError } = useHubSnackBar();

  useEffect(() => {
    isError && addSnackbarError({ title: "Error Merging Customers" });
  }, [isError]);

  useEffect(() => {
    isSuccess && onClose();
  }, [isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      id: formData.mainCustomerId,
      oldId: formData.oldCustomerId,
    };
    postMergeCustomerData(payload);
  };

  return (
    <HubDialogContent largePadding>
      <HubHookFormWrapper onSubmit={onSubmit}>
        <Stack gap="20px" alignItems="center">
          <Stack alignItems="center" textAlign="center">
            <Typography variant="h6">Merge Customers</Typography>
            <Typography variant="caption" sx={{ width: "80%" }}>
              Select the main customer then duplicate customer you wish to
              merge. Any Orders, Contacts, Addresses etc. will be merged to the
              main Customer <strong>This cannot be undone!</strong>
            </Typography>
          </Stack>
          <MergeCustomerForm disabled={isLoading} />
          <MergeCustomerButtons disabled={isLoading} />
        </Stack>
      </HubHookFormWrapper>
    </HubDialogContent>
  );
};

export default MergeCustomerContent;
